import { http } from '@shared/api';
import type { PlatformStats, Timeseries, TimeseriesParams } from './types';

export const statsApi = {
  get: () => http.get('stats').json<PlatformStats>(),

  timeseries: (params: TimeseriesParams) =>
    http
      .get('stats/timeseries', {
        searchParams: {
          from: params.from,
          to: params.to,
          groupBy: params.groupBy,
          actions: params.actions.join(','),
        },
      })
      .json<Timeseries>(),
};
